import React, { Fragment } from "react";
import { connect } from "react-redux";
import Accordion from "nekrasovka-ui/Accordion";
import Mention from "containers/Mention";
import Button from "nekrasovka-ui/Button";
import styled from "styled-components";
import Editing from "containers/Editing";

import editing from "modules/editing";
import search from "modules/search";
import Section from "components/Section";

const { editingToggle } = editing.actions;
const { fetchNextPage, clearSearch } = search.actions;

const SearchResultContainer = styled(Section)`
  margin-top: 40px;

  @media (max-width: 820px) {
    padding-left: 20px;
    padding-right: 20px;
  }
`;

const NoResults = styled(SearchResultContainer)`
  background: #ffffff;
  border: 1px solid #c4c4c4;
  box-sizing: border-box;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.03);
  border-radius: 5px;

  padding: 40px 20px;
  display: flex;
  justify-content: center;

  font-size: 21px;
  line-height: 25px;
  text-align: center;

  color: #16283f;
`;

class SearchResult extends React.Component {
  constructor() {
    super();
    this.state = {
      index: null,
      edit: false,
      editName: false,
      indexEdit: null
    };
  }

  componentWillReceiveProps(props) {
    this.setState({
      index: null,
      edit: false,
      indexEdit: null,
      editName: false
    });
  }

  componentWillUnmount() {
    this.props.clearSearch();
  }

  handleClick = (index, open) => {
    if (open) return this.setState({ index: null, edit: false });

    const state = { ...this.state };
    if (this.state.index !== index) {
      state.index = index;
      state.edit = false;
      state.indexEdit = null;
      state.indexEdit = false;
      this.setState(state);
    }
  };

  onEdit = (indexEdit, editName) => {
    if (editName) return this.setState({ indexEdit: null, editName: false });

    const state = { ...this.state };
    if (this.state.indexEdit !== indexEdit) {
      state.indexEdit = indexEdit;
      state.editName = false;
      state.index = null;
      state.edit = false;
      this.setState(state);
    }
  };

  render() {
    const { field, editing, result } = this.props;

    return (
      <SearchResultContainer>
        {result.length ? (
          <Fragment>
            {result.map((person, index) => {
              const open = this.state.index === index ? true : false;
              const editName = this.state.indexEdit === index ? true : false;
              const isNameSelected =
                person.id === field.id ||
                person["mentions"].some(mention => mention.id === field.id);
              return editing && isNameSelected ? (
                <Editing />
              ) : (
                <Accordion
                  key={index}
                  editName={editName}
                  title={person.name}
                  description={person.description}
                  open={open}
                  onHandleClick={() => this.handleClick(index, open)}
                  isContentDisabled={!!person.mentions.length}
                  onEditClick={() =>
                    !!person.mentions.length
                      ? this.setState({ edit: !this.state.edit })
                      : this.onEdit(index, editName)
                  }
                  person={`person/${person.id}`}
                  onTitleClick={() =>
                    this.state.edit || editName
                      ? this.props.editingToggle(person, "person")
                      : ""
                  }
                  onDescriptionClick={() =>
                    this.state.edit || editName
                      ? this.props.editingToggle(person, "person")
                      : ""
                  }
                >
                  {person.mentions.map((mention, index) => (
                    <Mention
                      key={index}
                      edit={this.state.edit}
                      mention={mention}
                    />
                  ))}
                </Accordion>
              );
            })}
            {this.props.result.length > 0 && !this.props.isFinished && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginBottom: "15px"
                }}
              >
                <Button
                  active
                  color="#000"
                  icon="loading"
                  widthIcon={15}
                  heightIcon={15}
                  onClick={this.props.fetchNextPage}
                >
                  Загрузить еще
                </Button>
              </div>
            )}
          </Fragment>
        ) : (
          <NoResults>
            По вашему запросу ничего не найдено. Попробуйте изменить запрос.
          </NoResults>
        )}
      </SearchResultContainer>
    );
  }
}

const mapStateToProps = state => ({
  editing: state.editing.editing,
  field: state.editing.field,
  result: state.search.result,
  isFinished: state.search.isSearchFinished
});

export default connect(
  mapStateToProps,
  {
    editingToggle,
    fetchNextPage,
    clearSearch
  }
)(SearchResult);



// WEBPACK FOOTER //
// ./src/containers/SearchResult/index.js